// Copia local de los grupos de envio ya mandados, guardada por proyecto.
//
// Borrar un grupo lo quita de la API para siempre, asi que sin esto el historial
// perderia justo el envio del que mas interesa dejar constancia. Antes de borrar
// se guarda aqui una copia y la fila sobrevive, marcada como borrada.
//
// Es una copia por navegador: si el grupo se borra desde otro equipo, aqui solo
// se puede saber que desaparecio, no cuando ni quien. Un historial compartido de
// verdad necesita borrado logico en la API (un deleted_at en
// project_submission_lists en vez del delete real); esto cubre lo que alcanza el
// front.
//
// Lo usan dos paginas: Follow-Up, que escribe y lee lo de su proyecto, y
// Submission History, que lee lo de todos.

const PREFIX = "followUpHistory:";

export const archiveKey = (project_id) => `${PREFIX}${project_id}`;

export const readArchive = (project_id) => {
	try {
		const stored = localStorage.getItem(archiveKey(project_id));
		const parsed = stored ? JSON.parse(stored) : null;

		// Un valor corrupto no puede tumbar la pagina: se descarta y se empieza de
		// cero, igual que con la seleccion de publishers.
		return parsed && typeof parsed === "object" ? parsed : {};
	} catch (error) {
		console.log(error);
		return {};
	}
};

export const writeArchive = (project_id, archive) => {
	try {
		localStorage.setItem(archiveKey(project_id), JSON.stringify(archive));
	} catch (error) {
		// Sin espacio o con el almacenamiento bloqueado se sigue adelante: se pierde
		// el rastro de los borrados, no la pagina.
		console.log(error);
	}
};

// Todos los proyectos archivados en este navegador. Lo usa Submission History,
// que mira el historial entero y no un proyecto concreto.
export const readAllArchives = () => {
	const archives = [];

	try {
		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);

			if (!key || key.indexOf(PREFIX) !== 0) {
				continue;
			}

			const project_id = key.slice(PREFIX.length);

			archives.push({project_id, entries: readArchive(project_id)});
		}
	} catch (error) {
		console.log(error);
	}

	return archives;
};

// Copia minima de un grupo enviado: solo lo que consumen las tablas de historial.
// El project_id va dentro porque Submission History recibe el envio suelto, sin
// el proyecto alrededor que lo situe.
export const snapshotList = (list, project_id) => ({
	id: list.id,
	project_id: list.project_id || project_id || null,
	sent_at: list.sent_at,
	contacts: (list.contacts || []).map(contact => ({
		contact_type: contact.contact_type,
		contact_id: contact.contact_id,
		sent_at: contact.sent_at || null
	})),
	files: (list.files || []).map(file => ({file_id: file.file_id})),
	deleted: false,
	deleted_at: null
});
